import SvgIcon from "../SvgIcon";
export default function createSvgIcon(path, displayName) {
    const Component = (props) => (<SvgIcon data-testid={`${displayName}Icon`} {...props}>
      {path()}
    </SvgIcon>);
    return Component;
}
